import React from "react";
import img2 from "../../assets/aboutPage/img2.svg";
import img3 from "../../assets/aboutPage/img3.svg";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import Card from "./Card";
import { cardData } from "./data";
const About = () => {
  return (
    <>
      <Header />
      <div className="about_page_wrapper">
        <div className="hero_section">
          <div className="container">
            <div className="content">
              <div className="hero_content">
                <h2>
                  we create Simple Solution <br /> For Your Complex task
                </h2>
                <p>
                  Lorem ipsum dolor sit amet, vel accumsan liberavisse ex, ea
                  nec elaboraret <br /> interpretaris, sed diceret
                  concludaturque no. Verear habemus sea ut
                </p>
                <div className="button">
                  <button className="work_btn glow neon">our work</button>
                  <button className="know_btn glow neon">Know more</button>
                  {/* <Link to="/" className="know_btn">
                    Know more
                  </Link> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="company_overview">
          <div className="container">
            <div className="overview_content">
              <div className="content">
                <div className="text_content">
                  <h2>
                    Overview Of Our <br /> Company
                  </h2>
                  <p>
                    Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                    diam nonumy eirmod tempor invidunt ut labore et dolore magna
                    aliquyam erat, sed diam voluptua. vero
                  </p>
                  <p>
                    Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                    diam nonumy eirmod tempor invidunt ut labore .
                  </p>
                </div>
                <div className="img">
                  <img
                    src={img2}
                    width="100%"
                    className="img-fluid"
                    alt="img3"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="always_help">
          <div className="container">
            <div className="always_content">
              <div className="content">
                <div className="img">
                  <img
                    src={img3}
                    width="100%"
                    className="img-fluid"
                    alt="img3"
                  />
                </div>
                <div className="text_content">
                  <h2>
                    We are here to <br /> always help you
                  </h2>
                  <p>
                    Lorem ipsum dolor sit amet, vel accumsan liberavisse ex, a
                    elaboraret interpretaris, sed diceret concludaturque nasdo
                    habemus sea ut. His nibh scripta in. In sea vocibus
                    facilisis.
                  </p>
                  <p>
                    vel cu paulo doctus vidsse. Iudico dicant nostrum nec aIn
                    detraxit eleifend duo, alterum iudicabit consectetuer per.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="satisfaction">
          <div className="container">
            <div className="section_title">
              <h2>What is the <br /> Speciality Of Us?</h2>
            </div>
            <div className="satisfaction_card">
              {cardData.map((d, i) => (
                <Card icon={d.icon} title={d.title} paragraph={d.para} />
              ))}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default About;
